import { FC, HTMLProps } from 'react'

import { UserObj } from '~generated/types'
import Avatar from '~lib/ui-kit/Avatar'

interface EditorProps extends HTMLProps<HTMLDivElement> {
  user: Partial<UserObj>
}

const Editor: FC<React.PropsWithChildren<EditorProps>> = ({ user, ...props }) => {
  return (
    <div {...props}>
      {user?.email && (
        <Avatar alt={user.name || user.email} color={user.avatarColor} size="sm" src={user.profileImage} />
      )}
    </div>
  )
}

export default Editor
